export default __webpack_public_path__ + "static/media/img_5.3a7dcd39.png";